import Chart from "react-apexcharts";
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { ApexOptions } from "apexcharts";
import { CSVLink } from "react-csv";
import { initialColumnMBUReport } from "../Projects/ManageColumn/ProjectModuleColumns";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStatusId } from "../../../core/data/redux/commonSlice";

const MbuReportingGraph = ({ data, displayMode, viewMode, selectedDateforParam, selectedEnterpriseOption,dateRange }: any) => {
    const safeResult = Array.isArray(data?.result) ? data?.result : [];
    const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [selectedId, setSelectedId] = useState(null)

    const maxValue = Math.max(
        ...safeResult.map((item: { statusCount: any; salePrice: any; }) =>
            displayMode === "count" ? item.statusCount ?? 0 : item.statusCount ?? 0
        )
    );
    console.log('maxValue',Math.ceil(maxValue * 1.4));
    
    const series = useMemo(
        () => [
            {
                data: safeResult.map((item: { statusCount: any }) => item.statusCount ?? 0),
            },
        ],
        [safeResult, displayMode]
    );
    const formatNumber = (num: number) => {
        if (num >= 1_000) return `${(num / 1_000).toFixed(1)}k`;
        return num.toString();
    };
    const options: ApexOptions = useMemo(
        () => ({
            chart: {
                type: "bar",
                height: 600,
                offsetX: 0,
                toolbar: {
                    show: false,
                },
                events: {
                    dataPointSelection: function (event, chartContext, config) {
                        const index = config.dataPointIndex;
                        const clickedItem = safeResult[index];

                        if (clickedItem) {
                            setSelectedId(clickedItem?.statusId)
                            navigate(`/reports/mbu-listing/${clickedItem?.statusId}/${selectedDateforParam?.startDate}/${selectedDateforParam?.endDate}`, {
                                state: { clickedItem }, // optional
                            });
                        }
                    },
                },
            },
            plotOptions: {
                bar: {
                    horizontal: true,

                    dataLabels: {
                        position: 'top',
                    },
                },
            },
            dataLabels: {
                enabled: true,
                offsetX: 70,
                style: {
                    fontSize: '12px',
                    colors: ['#212529'],
                },
                formatter: function (val: number, opts: any) {
                    if (val === 0) return '';
                    const index = opts.dataPointIndex;
                    const count = safeResult[index]?.statusCount ?? 0;
                    const price = safeResult[index]?.salePrice ?? 0;

                    const formattedCount = formatNumber(count);
                    const formattedPrice = formatNumber(price);

                    return displayMode === "count"
                        ? `${formattedCount} ($${formattedPrice})`
                        : `$${formattedPrice} (${formattedCount})`;
                },
            },
            colors: ["#b11f28"],
            yaxis: {
                labels: {
                    align: 'left',
                    style: {
                        fontSize: '14px',
                        fontWeight: '600',
                        textOverflow: 'initial'
                    },
                    maxWidth: 600,
                },
            },
            xaxis: {
                categories: safeResult.map((item: { statusName: any; }) => item.statusName || "Unknown"),
                 min: 0,
                max: Math.ceil(maxValue * 1.2),
            },
        }),
        [safeResult, displayMode]
    );

    //csv data 
    const headers = [
        { label: "Section Heading", key: "sectionHeading" },
        { label: "Action Name", key: "statusName" },
        { label: "Team Name", key: "teamName" },
        { label: "Period Count *", key: "statusCount" },
        { label: "YTD count *", key: "statusCount" },
        { label: "Period Volume *", key: "salePrice" },
        { label: "YTD Volume", key: "salePrice" },
    ];

    const CsvData = data?.result?.map((item: any) => ({
        sectionHeading: selectedEnterpriseOption?.label,
        statusName: item.statusName ?? "",
        teamName: "",
        statusCount: item.statusCount ?? "",
        salePrice: item.salePrice ?? "",
        ytdVolume: item.salePrice ?? "",
    })) || [];

    return (
        <div>
            {viewMode === "chart" ?
                <div id="last-chart">
                    <Chart
                        key={displayMode}
                        options={options}
                        series={series}
                        // type={chartOptions?.chart?.type}
                        type="bar"
                        height={600}
                    />
                </div>
                :
                <>
                    <div className=" w-25 mb-3">
                        <CSVLink data={CsvData} headers={headers} filename={`MBU_Reporting ${formattedDate}.csv`} className="btn btn-light-red d-flex justify-content-center gap-1 align-items-center">
                            <i className="fa fa-file-export" />
                            Export To CSV
                        </CSVLink>
                    </div>
                    <div className="table-responsive">
                        <table className="table datanew dataTable no-footer table-hover">
                            <thead>
                                <tr>
                                    <th>Section Heading</th>
                                    <th>Action Name</th>
                                    <th>Team Name </th>
                                    <th className='text-end'>Period Count *</th>
                                    <th className='text-end'>YTD count </th>
                                    <th className='text-end'>Period Volume *</th>
                                    <th className='text-end'>YTD Volume</th>
                                </tr>
                            </thead>
                            <tbody>
                                {safeResult.map((item: {
                                    salePrice: string;
                                    statusCount: string; statusName: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined;
                                }) => (
                                    <tr>
                                        <>
                                            <td>
                                                {selectedEnterpriseOption?.label}
                                            </td>
                                            <td>
                                                {item.statusName}
                                            </td>
                                            <td>

                                            </td>
                                            <td className='text-end' >
                                                {item.statusCount}
                                            </td>
                                            <td className='text-end'>
                                                {item.statusCount}
                                            </td>
                                            <td className='text-end'>
                                                {item.salePrice}
                                            </td>
                                            <td className='text-end'>
                                                {item.salePrice}
                                            </td>

                                        </>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                </>
            }
        </div >
    )
}

export default MbuReportingGraph